import {SmartComponent} from "smart-component-js";
import $ from "jquery";

class FeedbackModalComponent extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.init();
	}

	init() {
		$('.feedback__modal').css("display", "flex").fadeIn(300);
	}

	close(){
		console.log('close');
		$('.feedback__modal').remove();
	}
}


export default FeedbackModalComponent;